import { defineComponent, h, Teleport } from "vue";
const _sfc_main = defineComponent({
  name: "ConditionalTeleport",
  inheritAttrs: false,
  props: {
    to: {
      type: [String, Object],
      default: null
    },
    disabled: {
      type: Boolean,
      required: true
    }
  },
  slots: Object,
  setup(props, { slots }) {
    return () => {
      var _a, _b;
      return !props.to ? (_a = slots.default) == null ? void 0 : _a.call(slots, {}) : h(Teleport, { to: props.to, disabled: props.disabled || !props.to }, [(_b = slots.default) == null ? void 0 : _b.call(slots, {})]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=ConditionalTeleport.vue_vue_type_script_lang-BCI6afpC.mjs.map
